<template>
    <header class="header">
        <div class="wrap clearfix">
            <div class="logo fl">
                <img src="../assets/images/logo.png"alt=""  />
            </div>
            <div class='language fr' @click='languageShow=!languageShow'>
              <span id='language'>English <span @click.stop='languageShow=!languageShow'></span></span>
              <ul class="clearfix" v-if='languageShow'>
                  <li class='active'><a href="http://www.rihuacn.com/en" >English</a></li>
                  <li><a href="http://www.rihuacn.com/" >中文</a></li>
              </ul>
            </div>
            <div class="menu fr">
                <ul class="clearfix">
                    <li v-for="(item,index) in menus" class="fl">
                        <!-- <router-link :to="item.path"></router-link> -->
                        <a href="javascript:;"
                        @click="$router.push(item.path)"
                        :class="{active:item.path.indexOf(activePath)>-1}">{{item.name}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>
<script type="text/javascript">
export default {
    data(){
        return {
            menus: [
                {
                    name: 'Home',
                    path: '/index',
                },
                {
                    name: 'Products',
                    path: '/production',
                },
                {
                   name: 'Technology',
                   path: '/skill',
                },
                {
                    name: 'News',
                    path: '/information/0',
                },
                {
                    name: 'About Us',
                    path: '/about',
                },
                {
                    name: 'Contact',
                    path: '/concat',
                }
            ],
            language:'English',
            languageShow:false,
        }
    },
    computed:{
        activePath(){
            let path = this.$route.path;
            path = path.replace(/(\/\w+)(?:\/.*)?/,'$1')
            return path
        }
    },
    created(){
    },
    mounted(){
      document.body.addEventListener('click',this.languagestatus);

    },
    destoryed() {
        document.body.removeEventListener('click', this.languagestatus)
    },
    methods:{
      languagestatus(event){
        if(event.target.id!='language'){
          this.languageShow=false;
        }
      }
    }
}
</script>
<style lang="less" scoped>
    .header{
        position: fixed;
        z-index: 9999;
        width: 100%;
        height: 95px;
        background-color: #fff;
        top: 0;
        left: 0;
        h1{
            font-size: 24px;
            color: rgb(51, 51, 51);
            font-weight: 400;
            margin-top: 25px;
            margin-left: 10px;
        }
        .menu{
            height: 40px;
            margin-top: 20px;
            margin-right: 30px;
            li{
                height: 40px;
                line-height: 40px;
                margin-left: 20px;
                a{
                    display: block;
                    padding: 0 10px;
                    height: 100%;
                    color: rgb(102, 102, 102);
                    font-size: 16px;
                    &.active{
                        color: #fff;
                        background-color: #d72538;
                        border-radius: 5px;
                    }
                }
            }
        }
        .language{
            margin-top: 20px;
            margin-right: 30px;
            height: 40px;
            font-size: 16px;
            position: relative;
            span{
                height: 40px;
                line-height: 40px;
                margin-left: 20px;
                cursor: pointer;
                span{
                  display:inline-block;
                  width:0;
                  height:0;
                  position: relative;
                  top:3px;
                  left:-15px;
                  border-top:6px solid #d72538;
                  border-right:6px solid  rgba(0,0,0,0);
                  border-bottom:6px solid rgba(0,0,0,0);
                  border-left:6px solid  rgba(0,0,0,0);
                }
            }
            ul{
                background:#fff;
                border-radius:4px;
                position: absolute;
                li{
                    height: 40px;
                    line-height: 40px;
                    padding-left: 10px;
                    padding-right: 10px;
                    text-align: center;
                    a{
                        display: block;
                        padding: 0 10px;
                        height: 100%;
                        color: rgb(102, 102, 102);
                        font-size: 16px;
                        &.active{
                            color: #fff;
                            background-color: #d72538;
                            border-radius: 5px;
                        }
                    }
                }
                li:hover{
                  background:#d72538;
                  a{
                    color:#fff;
                  }
                }
                li.active{
                  background:#d72538;
                  a{
                    color:#fff;
                  }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/header.vue